import './style.css.js';
import { useClassNames } from '@magnetic/hooks';
import React, { memo, forwardRef } from 'react';

const Divider = memo(
  forwardRef(
    ({
      as,
      className,
      direction = "horizontal",
      intensity = "medium",
      size = "md",
      ...rest
    }, ref) => {
      const Component = as != null ? as : "div";
      const classNames = useClassNames(
        "mds-divider",
        `mds-divider-size-${size}`,
        `mds-divider-intensity-${intensity}`,
        `mds-divider-direction-${direction}`,
        className
      );
      return /* @__PURE__ */ React.createElement(Component, {
        ...rest,
        className: classNames,
        ref
      });
    }
  )
);

export { Divider };
//# sourceMappingURL=index.js.map
